<template>
    <div class="printList">
        <div class="flexwrap">
          <div class="img-box" @click.prevent.stop="previewImg(true,image_url)">
            <img :src="image_url" alt="preview-img" />
          </div>
          <div class="fr flexwrap">
            <p class="frt oneline">{{spec_name}}</p>
            <div id="price-number2" class="oneline money">{{singlePrice}}</div>
          </div>
        </div>
        <cell :cellName="`冲印版数（1版${sheets_number}小张）：`">
          <div slot="value" id="num-selector-container">
            <div class="num-selector">
              <div class="num-ctrl" @click="calcNum(-1)">-</div>
              <div class="num">{{printQty}}</div>
              <div class="num-ctrl" @click="calcNum(1)">+</div>
            </div>
            <div>版</div>
          </div>
        </cell>
    </div>
</template>
<script>
import Cell from '@/components/Form/Cell'
export default {
    name:'printList',
    components:{
        Cell
    },
    props:{
        image_url:{
            type:String,
            default:''
        },
        spec_name:{
            type:String,
            default:''
        },
        singlePrice:{
            type:Number,
            default:0
        },
        sheets_number:{
            type:Number,
            default:0
        },
        printQty:{
            type:Number,
            default:0
        },
        index:{
            type:Number,
            default:-1
        }
    },
    methods:{
        previewImg(bol,url){
            this.$emit('previewImg',bol,url)
        },
        calcNum(num){
            this.$emit('calcNum',num,this.index)
        }
    }
}
</script>
<style lang="scss" scoped>
.oneline{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .flexwrap{
    display: flex;
  }
  .cell {
          border-bottom: none;
          justify-content: space-between;
          padding:0;
          margin-bottom: -.14rem;
        }
    .img-box {
        width: 1rem;
        height: .69rem;
        padding: .05rem;
        box-shadow: 0 .02rem .04rem 0 rgba(172, 200, 255, 0.6);
        position: relative;
        flex-shrink: 0;
        margin-right: .12rem;
        &::before {
          content: '';
          width: 100%; height: 100%;
          position: absolute; z-index: 5;
          top: 0; left: 0;
        }
      }
      .fr{
        flex-direction: column;
        justify-content: space-around;
        overflow: hidden;
        .frt{
          font-size: .16rem;
          color:#363636;
          font-weight: bold;
        }
        .money::before{
          display: inline-block;
          content:'￥';
          font-size: .12rem;
        }
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      #price-number2 {
      color: #f63d30;
      font-size: .16rem;
    }
    #num-selector-container {
      display: flex;
      align-items: center;
    }
    .num-selector {
      display: flex;
      align-items: center;
      margin-right: .08rem;

      .num-ctrl {
        width: .14rem;
        height: .16rem;
        border: .01rem solid rgba(151, 151, 151, 0.4);
        border-radius: .01rem;
        line-height: .14rem;
        text-align: center;
      }

      .num {
        width: .3rem;
        text-align: center;
      }
    }
</style>